<template>
  <div class="home mt-5">
    <h2 class="text-align--center mb-4">Personointilomake</h2>
    <div class="text-align--center intro mb-2">
      Valitse malli:
    </div>
    <car-list></car-list>
  </div>
</template>

<script>
// @ is an alias to /src
import CarList from "@/components/CarList.vue";

export default {
  name: "home",
  components: {
    CarList
  },
  created() {
    this.$store.commit("clearChoises");
    this.$store.commit("clearCarImage");
    this.$store.commit("clearForm");
  }
};
</script>
